<template lang="pug">
LoaderOverlay(:loading="loading")
  img(:class="imgClass" :src="src" :alt="alt" @load="onLoad" @error="onError")
</template>

<script>
  import LoaderOverlay from './loader_overlay.vue'

  export default {
    components: {
      LoaderOverlay
    },

    props: {
      src: {
        type: String,
        required: true
      },

      alt: {
        type: String,
        default: () => ''
      },

      imgClass: {
        type: String,
        required: false
      }
    },

    data() {
      return {
        loading: true
      }
    },

    watch: {
      src(newSrc) {
        // If src is null or empty, don't show loading
        if (!newSrc) {
          this.loading = false
        } else {
          this.loading = true
        }
      }
    },

    mounted() {
      // If src is null or empty on mount, don't show loading
      if (!this.src) {
        this.loading = false
      }
    },

    methods: {
      onLoad() {
        this.loading = false
      },

      onError() {
        // Hide loading overlay if image fails to load
        this.loading = false
      }
    }
  }
</script>
